import {
	Text,
	TextInput,
	TextInputProps,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React, { useRef, useState } from 'react';
import { FORM_MESSAGE } from '../../../../constants/form-constants';
import { STYLED_INPUT } from '../../../../constants/styles-constants';
import { formService } from '../../../../form-service';
import { useFormField } from '../../../../hooks/use-form-field';

interface Props extends Omit<TextInputProps, 'onChange' | 'onFocus' | 'onBlur'> {
	name: string;
	label: string;
	value?: any;
	required?: boolean;
	disabled?: boolean;
	infoMessage?: string;
	secondaryMessage?: string;
	validate?: (value: string) => boolean;
	errorMessage?: string;
	hasError?: boolean;
	onChange?: (e: any) => void;
	onFocus?: (e: any) => void;
	onBlur?: (e: any) => void;
	icon?: React.ReactNode;
	inputRef?: React.RefObject<HTMLInputElement>;
	type?:
		| 'color'
		| 'email'
		| 'file'
		| 'hidden'
		| 'image'
		| 'month'
		| 'number'
		| 'password'
		| 'range'
		| 'search'
		| 'tel'
		| 'text'
		| 'time'
		| 'url'
		| 'week';
}

export function TextInputExtended(props: Props) {
	const {
		name,
		required,
		value,
		type,
		disabled,
		infoMessage,
		secondaryMessage,
		validate,
		errorMessage,
		hasError,
		onFocus,
		onChange,
		onBlur,
		icon,
	} = props;

	const { currentValue, validationError } = useFormField({
		name,
		value,
		required,
		validate,
	});
	const internalRef = useRef<HTMLInputElement>(null);
	const inputRef = props.inputRef || internalRef;

	const [isUsed, setIsUsed] = useState(false);

	const handleChange = (e: any) => {
		formService.setFieldValue(name, e.target.value);
	};

	const message =
		(hasError ?? validationError) ? (errorMessage ?? FORM_MESSAGE.REQUIRED_FIELD) : infoMessage || undefined;

	const appearance =
		(hasError ?? validationError) ? 'error' : disabled ? 'disabled' : infoMessage ? 'information' : 'default';

	const iconElement =
		icon != null ? <div style={{ marginTop: appearance && isUsed ? '-18px' : 0 }}>{icon}</div> : undefined;

	return (
		<div
			className="input"
			style={{
				marginLeft: STYLED_INPUT.margin.left,
				marginRight: STYLED_INPUT.margin.right,
				marginTop: STYLED_INPUT.margin.top,
				marginBottom: STYLED_INPUT.margin.bottom,
				height: STYLED_INPUT.height, // Usamos alto fijo para evitar cambio de altura con message
			}}
		>
			<TextInput
				{...props}
				ref={inputRef}
				value={currentValue}
				required={required}
				type={type || 'text'}
				// @ts-ignore (type date es correcto)
				isFloating={!currentValue && !value && type !== 'date'}
				message={message}
				appearance={appearance}
				icon={iconElement}
				onChange={(e: any) => {
					if (onChange) onChange(e);
					handleChange(e);
				}}
				onBlur={(e: any) => {
					if (onBlur) onBlur(e);
				}}
				onFocus={(e: any) => {
					setIsUsed(true);
					if (onFocus) onFocus(e);
				}}
			/>
			{secondaryMessage ? (
				<div style={{ marginTop: props.maxLength ? '-18px' : 0 }}>
					<Text appearance={TokenTextAppearance.copy100} color={TokenTextColor.secondary}>
						{secondaryMessage}
					</Text>
				</div>
			) : undefined}
		</div>
	);
}
